import { Text } from '@doda/io-react/common';
import { useAppSelector } from 'redux/hooks';
import { PageTitle } from '@doda/io-react/pc';
import { validationMessagesSelector } from 'redux/features/jobList';
import { jobListHeaderTextSelector } from 'redux/features/careerRecommendJobList';
import styles from './index.module.scss';

export const BodyHeader: React.FC = () => {
  const { isVisibleValidationMessages } = useAppSelector(
    validationMessagesSelector
  );
  const { title, explainText } = useAppSelector(jobListHeaderTextSelector);

  return (
    <div className={styles.careerRecommendJobList__contentsHeader}>
      {isVisibleValidationMessages ? (
        <PageTitle>求人情報の検索結果一覧</PageTitle>
      ) : (
        <>
          <PageTitle>{title}</PageTitle>
          <Text
            as="p"
            color="gray"
            size="12"
            weight="normal"
            className={styles.explainText}
          >
            {explainText}
          </Text>
        </>
      )}
    </div>
  );
};
